class LeadStage {
    static New() {
        return 1;
    }

    static Contacted() {
        return 2;
    }

    static Meeting() {
        return 3;
    }

    static Proposal() {
        return 4;
    }

    static Won() {
        return 5;
    }

    static Lost() {
        return 6;
    }
}

export const getLeadStageTranslationKey = (stage) => {
    switch (stage) {
        case LeadStage.New():
            return 'customer.leadStageNew';
        case LeadStage.Contacted():
            return 'customer.leadStageContacted';
        case LeadStage.Meeting():
            return 'customer.leadStageMeeting';
        case LeadStage.Proposal():
            return 'customer.leadStageProposal';
        case LeadStage.Won():
            return 'customer.leadStageWon';
        case LeadStage.Lost():
            return 'customer.leadStageLost';
        default:
            return null;
    }
};

// Builds the full list of pipeline stage options: in-progress stages come from the
// admin-configurable "LeadStage" parameter list (falls back to the original hardcoded
// four while parameters haven't loaded yet), Won/Lost are always fixed terminal stages.
export const buildLeadStageOptions = (configurableLeadStages, t) => {
    const middle =
        configurableLeadStages && configurableLeadStages.length > 0
            ? configurableLeadStages.map((p) => ({ value: p.id, label: p.value }))
            : [
                  { value: LeadStage.New(), label: t('customer.leadStageNew') },
                  { value: LeadStage.Contacted(), label: t('customer.leadStageContacted') },
                  { value: LeadStage.Meeting(), label: t('customer.leadStageMeeting') },
                  { value: LeadStage.Proposal(), label: t('customer.leadStageProposal') },
              ];
    return [
        ...middle,
        { value: LeadStage.Won(), label: t('customer.leadStageWon') },
        { value: LeadStage.Lost(), label: t('customer.leadStageLost') },
    ];
};

export default LeadStage;
